import { Button as Bs5Button } from 'react-bootstrap5';

export default Bs5Button;
